import { useTranslations } from '@vocab/react';
import {
  Stack,
  Heading,
  Actions,
  Text,
  Columns,
  Column,
} from 'braid-design-system';

import { analyticsEvents } from 'src/constants/analytics';
import { TRACKING_DASHBOARD_HERO } from 'src/constants/tracking';
import { getCreateNewJobUrl } from 'src/utils/getUrls';

import recentJobsTranslations from '../RecentJobs/.vocab';
import TrackingButtonLink from '../TrackingButtonLink/TrackingButtonLink';

import translations from './.vocab';
import type { HeroContentProps } from './Hero';

export const ExistingHirerHero = ({
  firstName,
  hasCreateJobsPermission,
}: HeroContentProps) => {
  const { t } = useTranslations(translations);
  const { t: jobTrans } = useTranslations(recentJobsTranslations);

  const createNewJobUrl = getCreateNewJobUrl();

  return (
    <Columns space="medium" collapseBelow="desktop">
      <Column width="2/3">
        <Stack space="medium">
          <Heading level="3" component="p">
            {t('Greeting message')} {firstName}
          </Heading>

          <Text size="large">
            {t('You are in the right place')}
            {hasCreateJobsPermission ? (
              <> {t('Get started by creating a job ad')}</>
            ) : null}
          </Text>

          <Actions>
            {hasCreateJobsPermission && (
              <TrackingButtonLink
                variant="solid"
                tone="formAccent"
                href={createNewJobUrl}
                trackingEventName={analyticsEvents.TRACK_CREATE_JOB}
                trackingActionOrigin={TRACKING_DASHBOARD_HERO}
                trackingData={{
                  isPrimaryCTA: true,
                  elementAction: 'internal redirect',
                  elementDesign: 'button',
                  elementText: 'Create a job ad',
                }}
              >
                {jobTrans('Create a job ad button')}
              </TrackingButtonLink>
            )}
          </Actions>
        </Stack>
      </Column>
    </Columns>
  );
};
